import { Col, Row } from "reactstrap";
import Drawer from "../../../assets/vfx/drawer/drawer";
import DisplayData from "../../common/DisplayData/DisplayData";
import { LookupAnswerTypeDto } from "../../../services/dto";
export interface AnswerTypeViewProps {
  data: LookupAnswerTypeDto | undefined;
  show: boolean;
  onHide: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export const AnswerTypeView = (props: AnswerTypeViewProps) => {
  return (
    <>
      <Drawer.View
        className="w-30"
        show={props.show}
        backdrop={true}
        placement="end"
        scroll={true}
        onHide={() => props.onHide()}
        onEdit={props.onEdit}
        title={props?.data?.name ?? "View Answer type"}
        showDeactivateOnHeader={true}
        modalDialogType="Delete"
        modalDialogProps={{
          contentText: "Are you sure you want to delete?",
          contentTitle: "Delete Answer type",
          closeText: "No, Go Back",
          confirmText: "Yes, Continue",
          open: false,
          onClose: () => {},
          onConfirm: () => {
            props.onDelete();
          },
        }}
        onDelete={props.onDelete}
      >
        <Row>
          <Col md={12}>
            <DisplayData text="Name" importedData={props?.data?.name} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <DisplayData
              text="Description"
              importedData={props?.data?.description}
              className="ms-0"
            />
          </Col>
        </Row>
      </Drawer.View>
    </>
  );
};
